import { useState } from "react";
import { createPortal } from "react-dom";
import { QrCode, X, Maximize2 } from "lucide-react";

const COLORS = {
  yellow: "bg-amber-400 text-ink border-amber-400",
  blue: "bg-blue-500 text-white border-blue-500",
  green: "bg-emerald-500 text-ink border-emerald-500",
  purple: "bg-violet-500 text-white border-violet-500",
  cyan: "bg-cyan-400 text-ink border-cyan-400",
  orange: "bg-brand text-white border-brand",
};
const TEXT = { yellow: "text-amber-300", blue: "text-blue-300", green: "text-emerald-300", purple: "text-violet-300", cyan: "text-cyan-300", orange: "text-brand" };

const fmtAt = (iso) => (iso ? new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : null);

export function StatusTimeline({ steps, result }) {
  return (
    <ol className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-2" data-testid="status-timeline">
      {steps.map((s, i) => (
        <li key={s.key} data-testid={`step-${s.key}`} data-done={s.done}
          className={`rounded-xl border p-3 flex flex-col gap-1 transition-colors ${s.done ? COLORS[s.color] : "bg-white/[0.03] border-white/10 text-slate-500"}`}>
          <span className="text-[10px] font-bold uppercase tracking-widest opacity-80">{i + 1}</span>
          <span className="text-xs font-black uppercase leading-tight">{s.label}</span>
          <span className={`text-[11px] font-semibold ${s.done ? "opacity-90" : TEXT[s.color]}`}>{s.detail || (s.done ? "Concluído" : "Pendente")}</span>
          {s.at && s.done && <span className="text-[10px] opacity-75">{fmtAt(s.at)}</span>}
        </li>
      ))}
      <li data-testid="step-RESULT" className={`rounded-xl border p-3 flex flex-col gap-1 ${result ? "bg-white text-ink border-white" : "bg-white/[0.03] border-white/10 text-slate-500"}`}>
        <span className="text-[10px] font-bold uppercase tracking-widest opacity-80">7</span>
        <span className="text-xs font-black uppercase leading-tight">Colocação Final</span>
        {result ? (
          <>
            <span className="font-display text-2xl font-black leading-none" data-testid="final-position">{result.position}º</span>
            <span className="text-[10px] font-semibold">de {result.total} • {result.time}</span>
          </>
        ) : <span className="text-[11px] font-semibold">Aguardando resultados</span>}
      </li>
    </ol>
  );
}

export function AthleteQr({ reg, qrUrl }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" data-testid={`qr-open-${reg.bib_code}`} onClick={() => setOpen(true)}
        className="group rounded-2xl bg-white p-3 flex flex-col items-center gap-2 hover:scale-[1.02] transition-transform shadow-lg shadow-black/30">
        {qrUrl ? <img src={qrUrl} alt="QR Code do atleta" className="w-32 h-32" /> : <div className="w-32 h-32 flex items-center justify-center"><QrCode className="w-10 h-10 text-slate-300 animate-pulse" /></div>}
        <span className="text-[10px] font-bold uppercase tracking-widest text-ink flex items-center gap-1"><Maximize2 className="w-3 h-3" /> Toque para ampliar</span>
      </button>
      {open && createPortal(
        <div className="fixed inset-0 z-[60] bg-white flex flex-col items-center justify-center p-6" onClick={() => setOpen(false)} data-testid="qr-fullscreen">
          <button type="button" data-testid="qr-close-btn" className="absolute top-4 right-4 w-11 h-11 rounded-full bg-ink text-white flex items-center justify-center"><X className="w-5 h-5" /></button>
          <p className="text-ink/60 text-xs font-bold uppercase tracking-[0.3em] mb-4">Apresente ao Staff</p>
          {qrUrl && <img src={qrUrl} alt="QR Code" className="w-[min(80vw,420px)] h-[min(80vw,420px)]" />}
          <p className="font-mono font-black text-4xl text-ink tracking-widest mt-4" data-testid="qr-bib">{reg.bib_code}</p>
          <p className="text-ink/70 text-sm font-semibold mt-1">{reg.runner?.full_name}</p>
          <p className="text-ink/50 text-xs mt-1">{reg.category?.name}</p>
        </div>, document.body)}
    </>
  );
}
